import React from "react";

const Modal = ({ show, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 mx-auto my-auto bg-[rgba(0,0,0,0.5)] t-0 l-0 flex justify-center items-center z-[1000] transition-opacity duration-300 animate-fadeIn h-full w-full border-[1px] border-[#C4C6CC]"
      style={{ boxShadow: "0px 0px 16px rgba(89, 92, 95, 0.12)" }}
    >
      <div className="bg-white max-h-[80%] min-w-1/2 w-1/2 rounded-[16px] transform transition-all duration-300 scale-95 opacity-100 animate-scaleIn">
        {children}
      </div>
    </div>
  );
};

export default Modal;
